import { Component, Inject } from '@angular/core';

import { AuthService } from '@ridango/core';
import Env from '@ridango/core/env';
import { ThemeFeature } from '@ridango/core/lib/enums/features.enum';

@Component({
    selector: 'gl-footer',
    templateUrl: './footer.component.html'
})
export class FooterComponent {
    themeFeature = ThemeFeature;

    constructor(public ridangoAuth: AuthService, @Inject('ENV') public env: Env) {}
}
